class OfferSaveController {

    constructor($rootScope, $state, $stateParams, eventsService, access) {
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.eventsService = eventsService;
        this.access = access;
    }

    $onInit() {
        this.activeTab = this.$stateParams.tab || 'offer';
        if ( !this.days || !this.treatments ) {
          this.days = [];
          this.treatments = [];

          this.eventpromise = this.eventsService.collectGrouped().then(response => {
            this.days = this.days.concat(response.SpaDay);
            this.treatments = this.treatments.concat(response.Treatment);
            return response;
          });
        }
    }
}

OfferSaveController.$inject = [ '$rootScope', '$state', '$stateParams', 'eventsService', 'access' ];

export default OfferSaveController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/offer/controllers/offer.save.controller.js